/** แบ่งข้อสอบเป็นหน้าตามค่า questionsPerPage ของชุดข้อสอบ */
export function chunk<T>(items: T[], size: number): T[][] {
  const perPage = Math.max(1, Math.floor(size));
  const pages: T[][] = [];
  for (let index = 0; index < items.length; index += perPage) {
    pages.push(items.slice(index, index + perPage));
  }
  return pages;
}

/** ข้อที่ n อยู่หน้าไหน (index เริ่มที่ 0 ทั้งคู่) */
export function pageOfIndex(questionIndex: number, size: number): number {
  const perPage = Math.max(1, Math.floor(size));
  return Math.floor(Math.max(0, questionIndex) / perPage);
}

/** ข้อแรกของหน้านั้นอยู่ลำดับที่เท่าไร — ใช้แสดงเลขข้อให้ตรงกับผังข้อสอบ */
export function firstIndexOfPage(page: number, size: number): number {
  const perPage = Math.max(1, Math.floor(size));
  return Math.max(0, page) * perPage;
}
